import { render, staticRenderFns } from "./MetricChooserCmb.vue?vue&type=template&id=18ac79a4"
import script from "./MetricChooserCmb.vue?vue&type=script&lang=ts"
export * from "./MetricChooserCmb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports